<script setup lang="ts">
type Props = {
  completionPercent: number
  steps?: number
  startColor?: string
  endColor?: string
}

const props = withDefaults(defineProps<Props>(), {
  steps: 5,
  startColor: 'var(--color-param)',
  endColor: 'var(--color-darker-param)',
})

const mainBarStyle = computed<{ background: string }>(() => {
  const str = `linear-gradient(to right, ${props.startColor}, ${props.endColor})`

  return { background: str }
})

const completedSteps = computed<number>(() => {
  return Math.floor((props.completionPercent * props.steps) / 100)
})
</script>

<template>
  <div
    class="sharedProfileCompletionBar"
    date-test-id="sharedProfileCompletionBar"
  >
    <div class="stepsWrap" :style="mainBarStyle">
      <div
        v-for="(step, index) in steps"
        :key="step"
        class="step"
        :date-test-id="'sharedProfileCompletionBar_' + index"
        :class="{
          lastComplete: index === completedSteps - 1,
          completed: index < completedSteps,
        }"
      >
        <div v-if="index === completedSteps" class="pin">
          <i class="fas fa-check" />
        </div>
      </div>
    </div>
    <div class="lastPin" :class="{ completed: completionPercent >= 100 }">
      <i class="fas fa-trophy" />
    </div>
  </div>
</template>

<style scoped>
.stepsWrap,
.sharedProfileCompletionBar {
  width: 100%;
  height: 24px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.step,
div.stepsWrap {
  width: 100%;
  height: 8px;
}

.stepsWrap {
  border-radius: 8px;
}

.step {
  position: relative;
  flex-shrink: 1;
  border-left: 2px solid var(--color-white);
  border-right: 2px solid var(--color-white);
  background-color: var(--color-grey);
}

.step:first-child {
  border-radius: 4px 0px 0px 4px;
  border-left: 0px;
}
.step:last-child {
  border-radius: 0px 4px 4px 0px;
  border-right: 0px;
}

.step.completed {
  background: rgb(235, 69, 124);
}

.step.lastComplete {
  background: linear-gradient(
    -45deg,
    rgb(255, 200, 87) 0%,
    rgb(235, 69, 124) 100%
  );
}

.pin {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #fec458;
  left: -14px;
  top: -9px;
}

.lastPin {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--color-grey);
  top: 0px;
}

.fa-check {
  color: var(--color-white);
  font-size: var(--font-size-small);
}

.fa-trophy {
  color: var(--color-white);
  font-size: var(--font-size-small);
}

.lastPin.completed {
  background-color: #fec458;
}
</style>
